/**
 * usePendingPdvsCount — compteur badge ModuleSelector (FEAT-VALIDATION-WORKFLOW).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchPendingPdvsCount } from '../lib/api';

export function usePendingPdvsCount() {
  return useQuery({
    queryKey: ['admin', 'pending-pdvs-count'],
    queryFn:  fetchPendingPdvsCount,
    staleTime: 60_000,
    retry: 1,
  });
}
